import { theme } from '@/theme/theme'

export const DEFAULT_COLUMN_WIDTH = '15rem'
// Note: Checkbox column for bulk selection
export const CHECKBOX_COLUMN_WIDTH = '4.8rem'
// Note: Row actions dropdown z-index to make sure it hides under the table header
export const ROW_ACTIONS_DROPDOWN_ZINDEX = theme.zIndex.level1
